<template>
  <el-dialog custom-class="dialog-modal-permission" :model-value="flagVisible" width="770px" :before-close="handleClose">
    <div class="modal-permission">
      <div class="modal-p-content text-that-needs-wrapping">
        <div class="modal-p-title">
          <span>Add your audio, in Hi-Res!</span>
        </div>
        <div class="modal-p-desc">
          <p>Do you or your product evangelists already have amazing recordings of your products? For the first time ever online, these fantastic real-world examples can be heard in their full resolution! Tell the full story of your products.</p>
          <p>If adding your audio content in Hi-Res is not part of your subscription, please contact <a href="mailto:sales@audiotestkitchen.com">sales@audiotestkitchen.com</a> to upgrade.</p>
        </div>
      </div>
      <div class="modal-p-img">
        <img src="@/assets/images/permissions/my_audio.png" alt="" />
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    flagVisible: Boolean
  },
  emits: ['closeModal'],
  data: function () {
    return {
    }
  },
  created: function () {
  },
  watch: {
  },
  methods: {
    handleClose: function () {
      this.$emit('closeModal')
    }
  }
}
</script>
